import { labelStyle } from '~src/branding';
import { Label } from '~src/components/Label';

import { FormElementWrapperProps } from '../types';
import { AntInputWrapper } from './style';

export const InputWrapper = ({ label, attention, size = 'middle', style, children }: FormElementWrapperProps) => {
  return (
    <AntInputWrapper {...{ attention, size, style }}>
      {label && <Label {...{ style: labelStyle() }}>{label}</Label>}
      {children}
    </AntInputWrapper>
  );
};
